var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { styleMap } from 'lit-html/directives/style-map.js';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-form-control.lit.scss';
import stylesGlobal from './_sds-form-control-global.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
import { SdsInputBase } from '../input/_sds-input-base';
import { SdsSelect } from '../dropdown/select/sds-select.lit';
import { SdsIconPicker } from '../icon-picker/sds-icon-picker.lit';
import { SdsMultiselect } from '../dropdown/multiselect/sds-multiselect.lit';
import { SdsInputMultilingualBase } from '../multilingual/_sds-input-multilingual-base';
import { SdsTimePicker } from '../time/components/picker/sds-time-picker.lit';
import { SdsDatePicker } from '../datepicker/date/sds-date-picker.lit';
import { SdsDateTimePicker, SdsDateTimeRange } from '../date-time';
import { SdsYearPicker } from '../datepicker/year/sds-year-picker.lit';
import { SdsSemiAnnualPicker } from '../datepicker/semi-annual/sds-semi-annual-picker.lit';
import { SdsMonthPicker } from '../datepicker/month/sds-month-picker.lit';
import { SdsQuarterPicker } from '../datepicker/quarter/sds-quarter-picker.lit';
import { SdsWeekPicker } from '../datepicker/week/sds-week-picker.lit';
import { SdsDateRange } from '../datepicker/date/sds-date-range.lit';
import { SdsYearRange } from '../datepicker/year/sds-year-range.lit';
import { SdsMonthRange } from '../datepicker/month/sds-month-range.lit';
import { SdsQuarterRange } from '../datepicker/quarter/sds-quarter-range.lit';
import { SdsWeekRange } from '../datepicker/week/sds-week-range.lit';
/**
 * Control that represents Form Control.
 *
 * @slot input - This slot is the container for the form control input, textarea, dropdown, date picker etc
 * @slot checkbox - This slot is the container for the form control checkbox
 * @slot horizontal-checkbox - This slot is the container for the form control horizontal-checkbox
 * @slot radio - This slot is the container for the form control radio
 * @slot text - This slot is the container for the form control text
 * @slot no-data - This slot is the container for the form control no-data
 * @slot content - This slot is the container for the form control custom content
 */
let SdsFormControl = (() => {
    var _SdsFormControl_cursorStyle_accessor_storage, _SdsFormControl_required_accessor_storage, _SdsFormControl_formTitle_accessor_storage, _SdsFormControl_label_accessor_storage, _SdsFormControl_labelIcon_accessor_storage, _SdsFormControl_iconAside_accessor_storage, _SdsFormControl_asideIcon_accessor_storage, _SdsFormControl_labelTooltip_accessor_storage, _SdsFormControl_disabled_accessor_storage, _SdsFormControl_horizontal_accessor_storage, _SdsFormControl_slotElement_accessor_storage, _SdsFormControl_checkbox_accessor_storage, _SdsFormControl_checkboxHorizontal_accessor_storage, _SdsFormControl_radio_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-form-control')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _required_decorators;
    let _required_initializers = [];
    let _required_extraInitializers = [];
    let _formTitle_decorators;
    let _formTitle_initializers = [];
    let _formTitle_extraInitializers = [];
    let _label_decorators;
    let _label_initializers = [];
    let _label_extraInitializers = [];
    let _labelIcon_decorators;
    let _labelIcon_initializers = [];
    let _labelIcon_extraInitializers = [];
    let _iconAside_decorators;
    let _iconAside_initializers = [];
    let _iconAside_extraInitializers = [];
    let _asideIcon_decorators;
    let _asideIcon_initializers = [];
    let _asideIcon_extraInitializers = [];
    let _labelTooltip_decorators;
    let _labelTooltip_initializers = [];
    let _labelTooltip_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _horizontal_decorators;
    let _horizontal_initializers = [];
    let _horizontal_extraInitializers = [];
    let _slotElement_decorators;
    let _slotElement_initializers = [];
    let _slotElement_extraInitializers = [];
    let _checkbox_decorators;
    let _checkbox_initializers = [];
    let _checkbox_extraInitializers = [];
    let _checkboxHorizontal_decorators;
    let _checkboxHorizontal_initializers = [];
    let _checkboxHorizontal_extraInitializers = [];
    let _radio_decorators;
    let _radio_initializers = [];
    let _radio_extraInitializers = [];
    var SdsFormControl = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this.stylesGlobal = stylesGlobal;
            this.unique = Math.random().toString(36).slice(2);
            _SdsFormControl_cursorStyle_accessor_storage.set(this, 'default');
            _SdsFormControl_required_accessor_storage.set(this, __runInitializers(this, _required_initializers, false));
            _SdsFormControl_formTitle_accessor_storage.set(this, (__runInitializers(this, _required_extraInitializers), __runInitializers(this, _formTitle_initializers, '')));
            _SdsFormControl_label_accessor_storage.set(this, (__runInitializers(this, _formTitle_extraInitializers), __runInitializers(this, _label_initializers, '')));
            _SdsFormControl_labelIcon_accessor_storage.set(this, (__runInitializers(this, _label_extraInitializers), __runInitializers(this, _labelIcon_initializers, '')));
            _SdsFormControl_iconAside_accessor_storage.set(this, (__runInitializers(this, _labelIcon_extraInitializers), __runInitializers(this, _iconAside_initializers, false)));
            _SdsFormControl_asideIcon_accessor_storage.set(this, (__runInitializers(this, _iconAside_extraInitializers), __runInitializers(this, _asideIcon_initializers, false)));
            _SdsFormControl_labelTooltip_accessor_storage.set(this, (__runInitializers(this, _asideIcon_extraInitializers), __runInitializers(this, _labelTooltip_initializers, '')));
            _SdsFormControl_disabled_accessor_storage.set(this, (__runInitializers(this, _labelTooltip_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsFormControl_horizontal_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _horizontal_initializers, false)));
            _SdsFormControl_slotElement_accessor_storage.set(this, (__runInitializers(this, _horizontal_extraInitializers), __runInitializers(this, _slotElement_initializers, void 0)));
            _SdsFormControl_checkbox_accessor_storage.set(this, (__runInitializers(this, _slotElement_extraInitializers), __runInitializers(this, _checkbox_initializers, void 0)));
            _SdsFormControl_checkboxHorizontal_accessor_storage.set(this, (__runInitializers(this, _checkbox_extraInitializers), __runInitializers(this, _checkboxHorizontal_initializers, void 0)));
            _SdsFormControl_radio_accessor_storage.set(this, (__runInitializers(this, _checkboxHorizontal_extraInitializers), __runInitializers(this, _radio_initializers, void 0)));
            this.handleSlotChange = (__runInitializers(this, _radio_extraInitializers), () => {
                this.cursorStyle = this.getInputElementForFocus() ? 'pointer' : 'default';
            });
            this.handleLabelClick = () => {
                const targetNode = this.getInputElementForFocus();
                if (!targetNode) {
                    return;
                }
                if (targetNode instanceof SdsInputBase || targetNode instanceof SdsInputMultilingualBase) {
                    targetNode.handleFocus();
                }
                else if ('showContextMenu' in targetNode &&
                    typeof targetNode.showContextMenu === 'function') {
                    targetNode.showContextMenu();
                }
            };
        }
        get cursorStyle() { return __classPrivateFieldGet(this, _SdsFormControl_cursorStyle_accessor_storage, "f"); }
        set cursorStyle(value) { __classPrivateFieldSet(this, _SdsFormControl_cursorStyle_accessor_storage, value, "f"); }
        /**
         * True if control's value is required.
         * @attr
         */
        get required() { return __classPrivateFieldGet(this, _SdsFormControl_required_accessor_storage, "f"); }
        set required(value) { __classPrivateFieldSet(this, _SdsFormControl_required_accessor_storage, value, "f"); }
        /**
         * The title of this form control.
         * @attr
         */
        get formTitle() { return __classPrivateFieldGet(this, _SdsFormControl_formTitle_accessor_storage, "f"); }
        set formTitle(value) { __classPrivateFieldSet(this, _SdsFormControl_formTitle_accessor_storage, value, "f"); }
        /**
         * The label of this form control.
         * @attr
         */
        get label() { return __classPrivateFieldGet(this, _SdsFormControl_label_accessor_storage, "f"); }
        set label(value) { __classPrivateFieldSet(this, _SdsFormControl_label_accessor_storage, value, "f"); }
        /**
         * The label with icon of this form control.
         * @attr
         */
        get labelIcon() { return __classPrivateFieldGet(this, _SdsFormControl_labelIcon_accessor_storage, "f"); }
        set labelIcon(value) { __classPrivateFieldSet(this, _SdsFormControl_labelIcon_accessor_storage, value, "f"); }
        /**
         * The position icon of this form control.
         * @attr
         * @deprecated - Use 'asideIcon' instead
         */
        get iconAside() { return __classPrivateFieldGet(this, _SdsFormControl_iconAside_accessor_storage, "f"); }
        set iconAside(value) { __classPrivateFieldSet(this, _SdsFormControl_iconAside_accessor_storage, value, "f"); }
        /**
         * The position icon of this form control.
         * @attr
         */
        get asideIcon() { return __classPrivateFieldGet(this, _SdsFormControl_asideIcon_accessor_storage, "f"); }
        set asideIcon(value) { __classPrivateFieldSet(this, _SdsFormControl_asideIcon_accessor_storage, value, "f"); }
        /**
         * The popover on icon of this form control.
         * @attr
         */
        get labelTooltip() { return __classPrivateFieldGet(this, _SdsFormControl_labelTooltip_accessor_storage, "f"); }
        set labelTooltip(value) { __classPrivateFieldSet(this, _SdsFormControl_labelTooltip_accessor_storage, value, "f"); }
        /**
         * True if control is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsFormControl_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsFormControl_disabled_accessor_storage, value, "f"); }
        /**
         * The position icon of this form control.
         * @attr
         */
        get horizontal() { return __classPrivateFieldGet(this, _SdsFormControl_horizontal_accessor_storage, "f"); }
        set horizontal(value) { __classPrivateFieldSet(this, _SdsFormControl_horizontal_accessor_storage, value, "f"); }
        get slotElement() { return __classPrivateFieldGet(this, _SdsFormControl_slotElement_accessor_storage, "f"); }
        set slotElement(value) { __classPrivateFieldSet(this, _SdsFormControl_slotElement_accessor_storage, value, "f"); }
        get checkbox() { return __classPrivateFieldGet(this, _SdsFormControl_checkbox_accessor_storage, "f"); }
        set checkbox(value) { __classPrivateFieldSet(this, _SdsFormControl_checkbox_accessor_storage, value, "f"); }
        get checkboxHorizontal() { return __classPrivateFieldGet(this, _SdsFormControl_checkboxHorizontal_accessor_storage, "f"); }
        set checkboxHorizontal(value) { __classPrivateFieldSet(this, _SdsFormControl_checkboxHorizontal_accessor_storage, value, "f"); }
        get radio() { return __classPrivateFieldGet(this, _SdsFormControl_radio_accessor_storage, "f"); }
        set radio(value) { __classPrivateFieldSet(this, _SdsFormControl_radio_accessor_storage, value, "f"); }
        render() {
            this.addGlobalStyle();
            return html `
            <div class="${this.getClasses()}" part="sds-form-control">
                ${this.renderTitle()} ${this.renderLabel()} ${this.renderLabelWithIcon()}
                ${'' /* @ToDO Kad:  All slots should be removed after refactoring all use cases. */}
                <slot name="input"></slot>
                <slot
                    name="checkbox"
                    style="${this.getStyle(this.checkbox, 'flex')}"
                    @slotchange="${() => this.requestUpdate()}"
                >
                </slot>
                <slot
                    name="radio"
                    style="${this.getStyle(this.radio, 'flex')}"
                    @slotchange="${() => this.requestUpdate()}"
                >
                </slot>
                <slot name="text"></slot>
                <slot name="content"></slot>
                ${'' /* @ToDO End */}
                <slot
                    name="checkbox-horizontal"
                    style="${this.getStyle(this.checkboxHorizontal, 'flex')}"
                    @slotchange="${() => this.requestUpdate()}"
                ></slot>
                <slot name="no-data"></slot>
                <slot
                    class="sds-form-control__slot"
                    style="display:block;"
                    @slotchange=${this.handleSlotChange}
                ></slot>
            </div>
        `;
        }
        getClasses() {
            return classMap({
                'sds-form-control': true,
                'sds-form-control--required': this.required,
                'sds-form-control--disabled': this.disabled,
                'sds-form-control--aside-icon': this.asideIcon || this.iconAside,
                'sds-form-control--horizontal': this.horizontal,
            });
        }
        renderLabel() {
            if (this.label && !this.labelIcon) {
                return html `
                <label
                    style="cursor: ${this.cursorStyle};"
                    part="sds-form-control-label"
                    class="sds-form-control__label"
                    for="${this.unique}"
                    @click="${this.handleLabelClick}"
                >
                    <sds-clipped-text basic text="${this.label}"></sds-clipped-text>
                </label>
            `;
            }
        }
        renderTitle() {
            if (this.formTitle) {
                return html `
                <div class="sds-form-control__title" @click="${this.handleLabelClick}">
                    <sds-clipped-text
                        style="cursor: ${this.cursorStyle};"
                        basic
                        text="${this.formTitle}"
                    ></sds-clipped-text>
                </div>
            `;
            }
        }
        renderLabelWithIcon() {
            if (this.label && this.labelIcon) {
                if (this.labelTooltip) {
                    return html `
                    <div class="sds-form-control__label-wrapper">
                        <label
                            style="cursor: ${this.cursorStyle};"
                            class="sds-form-control__label"
                            for="${this.unique}"
                            @click="${this.handleLabelClick}"
                        >
                            <sds-clipped-text basic text="${this.label}"></sds-clipped-text>
                        </label>
                        <sds-tooltip basic position="up">
                            <sds-icon
                                slot="trigger"
                                class="sds-form-control__icon"
                                size="16"
                                name="${this.labelIcon}"
                            ></sds-icon>
                            <div slot="text">${this.labelTooltip}</div>
                        </sds-tooltip>
                    </div>
                `;
                }
                else {
                    return html `
                    <div class="sds-form-control__label-wrapper">
                        <label
                            style="cursor: ${this.cursorStyle};"
                            class="sds-form-control__label"
                            for="${this.unique}"
                            @click="${this.handleLabelClick}"
                        >
                            <sds-clipped-text basic text="${this.label}"></sds-clipped-text>
                        </label>
                        <sds-icon
                            part="sds-form-control-icon"
                            class="sds-form-control__icon"
                            size="16"
                            name="${this.labelIcon}"
                            @click="${(event) => this.dispatchAction(event)}"
                        ></sds-icon>
                    </div>
                `;
                }
            }
        }
        getInputElementForFocus() {
            var _a;
            return (_a = this.slotElement) === null || _a === void 0 ? void 0 : _a.assignedElements().find(node => {
                return this.isFocusableInput(node) || this.hasContextMenu(node);
            });
        }
        isFocusableInput(node) {
            return ((node instanceof SdsInputBase || node instanceof SdsInputMultilingualBase) &&
                !node.disabled);
        }
        hasContextMenu(node) {
            return [
                SdsSelect,
                SdsMultiselect,
                SdsIconPicker,
                SdsTimePicker,
                SdsDatePicker,
                SdsDateTimePicker,
                SdsYearPicker,
                SdsSemiAnnualPicker,
                SdsMonthPicker,
                SdsQuarterPicker,
                SdsWeekPicker,
                SdsDateRange,
                SdsDateTimeRange,
                SdsYearRange,
                SdsMonthRange,
                SdsQuarterRange,
                SdsWeekRange,
            ].some(type => node instanceof type);
        }
        getStyle(el, style) {
            return styleMap({ display: el.length > 0 ? style : 'contents' });
        }
        addGlobalStyle() {
            if (!document.head.querySelector('#sds-form-control')) {
                const formStyles = document.createElement('style');
                formStyles.id = 'sds-form-control';
                formStyles.innerHTML = this.stylesGlobal.cssText;
                document.head.appendChild(formStyles);
            }
        }
        dispatchAction(event) {
            this.dispatchEvent(new CustomEvent(SdsFormControl.ICON_ACTION_EVENT, {
                detail: { name: this.labelIcon },
                bubbles: false,
                composed: false,
            }));
            event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
    };
    _SdsFormControl_cursorStyle_accessor_storage = new WeakMap();
    _SdsFormControl_required_accessor_storage = new WeakMap();
    _SdsFormControl_formTitle_accessor_storage = new WeakMap();
    _SdsFormControl_label_accessor_storage = new WeakMap();
    _SdsFormControl_labelIcon_accessor_storage = new WeakMap();
    _SdsFormControl_iconAside_accessor_storage = new WeakMap();
    _SdsFormControl_asideIcon_accessor_storage = new WeakMap();
    _SdsFormControl_labelTooltip_accessor_storage = new WeakMap();
    _SdsFormControl_disabled_accessor_storage = new WeakMap();
    _SdsFormControl_horizontal_accessor_storage = new WeakMap();
    _SdsFormControl_slotElement_accessor_storage = new WeakMap();
    _SdsFormControl_checkbox_accessor_storage = new WeakMap();
    _SdsFormControl_checkboxHorizontal_accessor_storage = new WeakMap();
    _SdsFormControl_radio_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsFormControl");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _required_decorators = [property({ type: Boolean })];
        _formTitle_decorators = [property({ type: String, attribute: 'form-title' })];
        _label_decorators = [property({ type: String })];
        _labelIcon_decorators = [property({ type: String, attribute: 'label-icon' })];
        _iconAside_decorators = [property({ type: Boolean })];
        _asideIcon_decorators = [property({ type: Boolean, attribute: 'aside-icon' })];
        _labelTooltip_decorators = [property({ type: String, attribute: 'label-tooltip' })];
        _disabled_decorators = [property({ type: Boolean })];
        _horizontal_decorators = [property({ type: Boolean })];
        _slotElement_decorators = [query('slot:not([name])')];
        _checkbox_decorators = [queryAssignedElements({ slot: 'checkbox' })];
        _checkboxHorizontal_decorators = [queryAssignedElements({ slot: 'checkbox-horizontal' })];
        _radio_decorators = [queryAssignedElements({ slot: 'radio' })];
        __esDecorate(_classThis, null, _required_decorators, { kind: "accessor", name: "required", static: false, private: false, access: { has: obj => "required" in obj, get: obj => obj.required, set: (obj, value) => { obj.required = value; } }, metadata: _metadata }, _required_initializers, _required_extraInitializers);
        __esDecorate(_classThis, null, _formTitle_decorators, { kind: "accessor", name: "formTitle", static: false, private: false, access: { has: obj => "formTitle" in obj, get: obj => obj.formTitle, set: (obj, value) => { obj.formTitle = value; } }, metadata: _metadata }, _formTitle_initializers, _formTitle_extraInitializers);
        __esDecorate(_classThis, null, _label_decorators, { kind: "accessor", name: "label", static: false, private: false, access: { has: obj => "label" in obj, get: obj => obj.label, set: (obj, value) => { obj.label = value; } }, metadata: _metadata }, _label_initializers, _label_extraInitializers);
        __esDecorate(_classThis, null, _labelIcon_decorators, { kind: "accessor", name: "labelIcon", static: false, private: false, access: { has: obj => "labelIcon" in obj, get: obj => obj.labelIcon, set: (obj, value) => { obj.labelIcon = value; } }, metadata: _metadata }, _labelIcon_initializers, _labelIcon_extraInitializers);
        __esDecorate(_classThis, null, _iconAside_decorators, { kind: "accessor", name: "iconAside", static: false, private: false, access: { has: obj => "iconAside" in obj, get: obj => obj.iconAside, set: (obj, value) => { obj.iconAside = value; } }, metadata: _metadata }, _iconAside_initializers, _iconAside_extraInitializers);
        __esDecorate(_classThis, null, _asideIcon_decorators, { kind: "accessor", name: "asideIcon", static: false, private: false, access: { has: obj => "asideIcon" in obj, get: obj => obj.asideIcon, set: (obj, value) => { obj.asideIcon = value; } }, metadata: _metadata }, _asideIcon_initializers, _asideIcon_extraInitializers);
        __esDecorate(_classThis, null, _labelTooltip_decorators, { kind: "accessor", name: "labelTooltip", static: false, private: false, access: { has: obj => "labelTooltip" in obj, get: obj => obj.labelTooltip, set: (obj, value) => { obj.labelTooltip = value; } }, metadata: _metadata }, _labelTooltip_initializers, _labelTooltip_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _horizontal_decorators, { kind: "accessor", name: "horizontal", static: false, private: false, access: { has: obj => "horizontal" in obj, get: obj => obj.horizontal, set: (obj, value) => { obj.horizontal = value; } }, metadata: _metadata }, _horizontal_initializers, _horizontal_extraInitializers);
        __esDecorate(_classThis, null, _slotElement_decorators, { kind: "accessor", name: "slotElement", static: false, private: false, access: { has: obj => "slotElement" in obj, get: obj => obj.slotElement, set: (obj, value) => { obj.slotElement = value; } }, metadata: _metadata }, _slotElement_initializers, _slotElement_extraInitializers);
        __esDecorate(_classThis, null, _checkbox_decorators, { kind: "accessor", name: "checkbox", static: false, private: false, access: { has: obj => "checkbox" in obj, get: obj => obj.checkbox, set: (obj, value) => { obj.checkbox = value; } }, metadata: _metadata }, _checkbox_initializers, _checkbox_extraInitializers);
        __esDecorate(_classThis, null, _checkboxHorizontal_decorators, { kind: "accessor", name: "checkboxHorizontal", static: false, private: false, access: { has: obj => "checkboxHorizontal" in obj, get: obj => obj.checkboxHorizontal, set: (obj, value) => { obj.checkboxHorizontal = value; } }, metadata: _metadata }, _checkboxHorizontal_initializers, _checkboxHorizontal_extraInitializers);
        __esDecorate(_classThis, null, _radio_decorators, { kind: "accessor", name: "radio", static: false, private: false, access: { has: obj => "radio" in obj, get: obj => obj.radio, set: (obj, value) => { obj.radio = value; } }, metadata: _metadata }, _radio_initializers, _radio_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsFormControl = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.ICON_ACTION_EVENT = 'sds.form-control.icon';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsFormControl = _classThis;
})();
export { SdsFormControl };
